// src/pages/MatrizList.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Typography } from '@mui/material';
import api from '../api/axiosConfig';

const MatrizList = () => {
  const { idPoa } = useParams();
  const navigate = useNavigate();
  const [actividades, setActividades] = useState([]);

  useEffect(() => {
    const fetchActividades = async () => {
      try {
        const res = await api.get(`/poa-actividades/?id_poa_proyecto=${idPoa}`);
        setActividades(res.data);
      } catch (err) {
        console.error('Error al cargar actividades:', err);
      }
    };
    fetchActividades();
  }, [idPoa]);

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Matriz Lógica (POA #{idPoa})</Typography>
        <Button
          variant="contained"
          onClick={() => navigate(`/poa/${idPoa}/matriz/nuevo`)}
        >
          Nueva Actividad
        </Button>
      </Box>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Descripción</TableCell>
              <TableCell>Producto</TableCell>
              <TableCell>Cantidad</TableCell>
              <TableCell>Resultado</TableCell>
              <TableCell>Indicador</TableCell>
              <TableCell>Frecuencia</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {actividades.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">No hay actividades registradas</TableCell>
              </TableRow>
            ) : (
              actividades.map((act) => (
                <TableRow key={act.id_poatres_actividad}>
                  <TableCell>{act.descripcion || '—'}</TableCell>
                  <TableCell>{act.producto || '—'}</TableCell>
                  <TableCell>{act.cantidad}</TableCell>
                  <TableCell>{act.resultado || '—'}</TableCell>
                  <TableCell>{act.indicador || '—'}</TableCell>
                  <TableCell>{act.frecuencia}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default MatrizList;